export default __webpack_public_path__ + "static/media/ri.56cd4fb3.jpg";